import styled from '@emotion/styled';
import { useEffect } from 'react';

import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';

import ApiKey from './components/ApiKey';
import Billing from './components/Billing';
import { ProfileDetails } from './components/ProfileDetails';

const Container = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-direction: row;
    overflow: auto;
    gap: 30px;
`;

export default function AccountSettings() {
    const mixpanel = useAnalytics();
    const { user } = useAuth();

    useEffect(() => {
        mixpanel?.track('account-settings', { event: 'view' });
    }, []);

    if (!user) {
        return null;
    }
    const userName = `${user.given_name ?? ''} ${user.family_name ?? ''}`;
    return (
        <Container>
            <ProfileDetails picture={user.picture} name={userName} email={user.email} flex={1} />
            <Billing flex={1} />
            <ApiKey flex={1} />
        </Container>
    );
}
